export const localStorageKeys = {
  sessionStore: 'session-store',
  userPlaceNodeStore: 'user-place-node-store',
  offlineModeStore: 'offline-mode-store',
  homeTabStore: 'home-tab-store',
  languageStore: 'language-store',
  indicatedIssueLabelsCacheStore: 'indicated-issue-labels-cache-store',
} as const
